module.exports = __webpack_public_path__ + "static/media/analizingData.20407d7f.svg";